export const SearchErrorIcon = () => (
  <svg
    width="140"
    height="120"
    viewBox="0 0 140 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1289_19175)">
      <path
        d="M39.2 119.998H14C6.3 119.998 0 113.824 0 106.056V30.3716C0 22.7035 6.2 16.4297 14 16.4297H39.3C47 16.4297 53.3 22.604 53.3 30.3716V106.156C53.2 113.824 46.9 119.998 39.2 119.998Z"
        fill="#EAF0FA"
      />
      <path
        d="M102.5 16.4297H48.1001C52.6001 19.2181 55.6001 24.1973 55.6001 29.8737V106.554C55.6001 112.231 52.6001 117.21 48.1001 119.998H102.5C110 119.998 116 114.023 116 106.554V29.8737C116 22.4048 110 16.4297 102.5 16.4297Z"
        fill="#EAF0FA"
      />
      <path
        d="M37.8002 40.9277H14.8002C12.8002 40.9277 11.2002 39.3343 11.2002 37.3426V36.3468C11.2002 34.3551 12.8002 32.7617 14.8002 32.7617H37.8002C39.8002 32.7617 41.4002 34.3551 41.4002 36.3468V37.3426C41.4002 39.3343 39.8002 40.9277 37.8002 40.9277Z"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.8002 55.5683H14.8002C12.8002 55.5683 11.2002 53.975 11.2002 51.9833V50.9874C11.2002 48.9957 12.8002 47.4023 14.8002 47.4023H37.8002C39.8002 47.4023 41.4002 48.9957 41.4002 50.9874V51.9833C41.4002 53.975 39.8002 55.5683 37.8002 55.5683Z"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.2002 85.543H41.4002"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.2002 92.3164H41.4002"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.2002 99.0859H41.4002"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M103.5 45.9102C101.7 45.9102 100.3 44.516 100.3 42.7235V17.2297C100.3 15.5367 101.7 14.043 103.5 14.043H103.6C105.3 14.043 106.8 15.4372 106.8 17.2297V42.7235C106.7 44.516 105.3 45.9102 103.5 45.9102Z"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M103.5 58.6586C105.267 58.6586 106.7 57.2319 106.7 55.4719C106.7 53.7119 105.267 52.2852 103.5 52.2852C101.732 52.2852 100.3 53.7119 100.3 55.4719C100.3 57.2319 101.732 58.6586 103.5 58.6586Z"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M103.5 71.7015C123.106 71.7015 139 55.8735 139 36.3488C139 16.824 123.106 0.996094 103.5 0.996094C83.8939 0.996094 68 16.824 68 36.3488C68 55.8735 83.8939 71.7015 103.5 71.7015Z"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1289_19175">
        <rect width="140" height="120" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
